import { Outlet, ScrollRestoration } from "react-router";

export const App = () => {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
};

export default App;
